module.exports = __webpack_public_path__ + "img/first-prize.b1fcbc19.png";